"use client"

import clsx from "clsx"
import React, { ReactNode } from "react"

export interface InfoBoxProps {
  children: ReactNode
  className?: string
}

const InfoBox: React.FC<InfoBoxProps> = ({ children, className }) => {
  return <div className={clsx("mb-4 rounded-lg bg-nelo-sky-50 p-4 text-sm", className)}>{children}</div>
}

export default InfoBox
